import { IStringObj, IObj } from 'src/constants/types'

type GTagSet = {
  field: string
  value: string
}

const set = ({ field, value }: GTagSet): void => {
  try {
    // @ts-ignore пока пропустил
    window?.gtag('set', { [field]: value })
  } catch (err) {
    console.log('gtag set', err)
  }
}

const setUserProperties = (data: IObj<string | undefined>): void => {
  try {
    // @ts-ignore пока пропустил
    window?.gtag('set', 'user_properties', data)
  } catch (err) {
    console.log('gtag set', err)
  }
}

const event = (name: string, data?: IStringObj) => {
  try {
    // @ts-ignore пока пропустил
    window?.gtag('event', name, data)
  } catch (err) {
    console.log('gtag event', err)
  }
}

const pageview = (url: string): void => {
  try {
    // @ts-ignore пока пропустил
    event('page_view', {
      page_path: url
    })
  } catch (err) {
    console.log('gtag pageview', err)
  }
}

export default { pageview, set, event, setUserProperties }
